import React, { useEffect } from 'react';

export const QuotationInfo = ({ details, onChange }) => {

  useEffect(() => {
    // 1. Generate Date
    const today = new Date();
    const dateStr = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;

    // 2. Generate Quotation No
    const currentYear = today.getFullYear();
    let seqStr = localStorage.getItem('quotation_sequence');

    let nextNumber = 1;
    let nextLetterCode = 65; // 'A'

    if (seqStr) {
      const seq = JSON.parse(seqStr);
      if (seq.year === currentYear) {
        nextNumber = seq.number + 1;
        nextLetterCode = seq.letterCode;
        if (nextNumber > 99) {
          nextNumber = 1;
          nextLetterCode += 1;
        }
      }
    }
    // Save the new sequence
    localStorage.setItem('quotation_sequence', JSON.stringify({ year: currentYear, number: nextNumber, letterCode: nextLetterCode }));

    const letter = String.fromCharCode(nextLetterCode);
    const quotationNo = `VK/${nextNumber}-${letter}/${currentYear}`;

    // Only set if not already set, to prevent infinite loops, or just let parent handle initial state
    // But parent will just pass down empty. We should call onChange for date and quotationNo
    if (!details.date || !details.quotationNo) {
      onChange('date', dateStr);
      onChange('quotationNo', quotationNo);
    }
  }, []); // Run only on mount

  const formatValue = (val) => {
    if (!val) return '';
    if (typeof val === 'string' || typeof val === 'number') return val;
    if (typeof val === 'object') {
      return val.name || val.fullName || val.customerName || val.customId ||
        ((val.firstName || val.lastName) ? `${val.firstName || ''} ${val.lastName || ''}`.trim() : '') ||
        val.email || val.phone || '';
    }
    return String(val);
  };

  return (
    <div className="bg-white border border-slate-200 shadow-sm rounded-lg overflow-hidden mb-4">
      {/* Header */}
      <div className="bg-black text-white text-center py-1.5 font-bold text-sm tracking-wide uppercase">
        QUOTATION
      </div>

      {/* Grid container */}
      <div className="grid grid-cols-[auto_1fr_auto_1fr] text-sm border-t border-black bg-white">

        {/* Row 1 */}
        <div className="border-r border-b border-black px-1 py-[3px] flex items-center bg-slate-50/50">
          <span className="font-medium text-[13px] whitespace-nowrap text-slate-700">Customer Name & Ph. : -</span>
        </div>
        <div className="border-r border-b border-black px-1 py-[3px] min-w-[150px]">
          <input
            type="text"
            value={formatValue(details.projectName)}
            onChange={(e) => onChange('projectName', e.target.value)}
            className="w-full h-full bg-transparent outline-none placeholder:text-slate-300 text-[13px]"
            placeholder="Name & Phone"
          />
        </div>
        <div className="border-r border-b border-black px-1 py-[3px] flex items-center bg-slate-50/50">
          <span className="font-medium text-[13px] whitespace-nowrap text-slate-700">Date :</span>
        </div>
        <div className="border-b border-black px-1 py-[3px] min-w-[150px]">
          <input
            type="text"
            value={formatValue(details.date)}
            readOnly
            className="w-full h-full bg-transparent outline-none text-slate-700 text-center cursor-default text-[13px]"
            placeholder="Date"
          />
        </div>

        {/* Row 2 */}
        <div className="border-r border-b border-black px-1 py-[3px] flex items-center bg-slate-50/50">
          <span className="font-medium text-[13px] whitespace-nowrap text-slate-700">Location</span>
        </div>
        <div className="border-r border-b border-black px-1 py-[3px]">
          <input
            type="text"
            value={formatValue(details.site)}
            onChange={(e) => onChange('site', e.target.value)}
            className="w-full h-full bg-transparent outline-none placeholder:text-slate-300 text-[13px]"
            placeholder="Location"
          />
        </div>
        <div className="border-r border-b border-black px-1 py-[3px] flex items-center bg-slate-50/50">
          <span className="font-medium text-[13px] whitespace-nowrap text-slate-700">Quotation No.</span>
        </div>
        <div className="border-b border-black px-1 py-[3px]">
          <input
            type="text"
            value={formatValue(details.quotationNo)}
            readOnly
            className="w-full h-full bg-transparent outline-none text-slate-700 text-center cursor-default text-[13px]"
            placeholder="Quotation number"
          />
        </div>

        {/* Row 3 */}
        <div className="border-r border-black px-1 py-[3px] flex items-center bg-slate-50/50">
          <span className="font-medium text-[13px] whitespace-nowrap text-slate-700">Contact Ref:</span>
        </div>
        <div className="border-r border-black px-1 py-[3px]">
          <input
            type="text"
            value={formatValue(details.contactRef)}
            readOnly
            className="w-full h-full bg-transparent outline-none placeholder:text-slate-300 text-[13px]"
            placeholder="Contact Reference"
          />
        </div>
        <div className="border-r border-black px-1 py-[3px] flex items-center bg-slate-50/50">
          <span className="font-medium text-[13px] whitespace-nowrap text-slate-700">Reference / Designer</span>
        </div>
        <div className="px-1 py-[3px]">
          <input
            type="text"
            value={formatValue(details.referenceDesigner || details.designer)}
            onChange={(e) => onChange('referenceDesigner', e.target.value)}
            className="w-full h-full bg-transparent outline-none placeholder:text-slate-300 text-center text-[13px]"
            placeholder="Ref or designer"
          />
        </div>
      </div>
    </div>
  );
};
